import { render, staticRenderFns } from "./UploadEditDialog.vue?vue&type=template&id=54e5b973&"
import script from "./UploadEditDialog.vue?vue&type=script&lang=js&"
export * from "./UploadEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadEditDialog.vue?vue&type=style&index=0&id=54e5b973&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports